export const FLASHCARDS = [
    {
       "id":1,
       "topic_id":100,
       "title":"What protocol maps IPv4 addresses to MAC addresses?",
       "desc":"Address Resolution Protocol (ARP)"
    },
    {
       "id":2,
       "topic_id":100,
       "title":"What protocol operates at layers 1 and 2?",
       "desc":"802.3 Ethernet"
    },
    {
       "id":3,
       "topic_id":100,
       "title":"What layer does the point to point protocol (PPP) operate at?",
       "desc":"Layer 2"
    },
    {
       "id":4,
       "topic_id":100,
       "title":"All hosts connected at layer 2 are in the same ___________________.",
       "desc":"Subnet or broadcast domain"
    },
    {
       "id":5,
       "topic_id":100,
       "title":"What is the primary difference between TCP and UDP?",
       "desc":"TCP has sequence numbers."
    },
    {
       "id":6,
       "topic_id":100,
       "title":"Number of subnets or broadcast domains a virtual LAN (VLAN) represents",
       "desc":"One"
    },
    {
       "id":7,
       "topic_id":100,
       "title":"Number of collision domains on a half-duplex link",
       "desc":"One"
    },
    {
       "id":8,
       "topic_id":100,
       "title":"Default global aging time for MAC address table",
       "desc":"5 minutes"
    },
    {
       "id":9,
       "topic_id":100,
       "title":"True/False: Unknown unicast frames are always flooded.",
       "desc":"TRUE"
    },
    {
       "id":10,
       "topic_id":100,
       "title":"True/False: When the MAC address table is full, the oldest entries are deleted.",
       "desc":"FALSE"
    },
    {
       "id":11,
       "topic_id":100,
       "title":"What is the maximum size of the Data field in an Ethernet frame, measured in bytes?",
       "desc":"1,500 bytes"
    },
    {
       "id":12,
       "topic_id":100,
       "title":"Default Spanning Tree bridge priority",
       "desc":"32,768"
    },
    {
       "id":13,
       "topic_id":100,
       "title":"Spanning Tree extension that prohibits a bridge from becoming root",
       "desc":"Root Guard"
    },
    {
       "id":14,
       "topic_id":100,
       "title":"Interface command to turn a switchport into a routed interface",
       "desc":"no switchport"
    },
    {
       "id":15,
       "topic_id":100,
       "title":"Maximum number of active physical interfaces in an EtherChannel",
       "desc":"Eight"
    },
    {
       "id":16,
       "topic_id":100,
       "title":"How many IP addresses can be assigned to a routed interface?",
       "desc":"Two"
    },
    {
       "id":17,
       "topic_id":100,
       "title":"Switch feature that synchronizes state information such as the Forwarding Information Base (FIB) and Cisco Express Forwarding (CEF)",
       "desc":"Stateful switchover (SSO)"
    },
    {
       "id":18,
       "topic_id":100,
       "title":"Maximum number of backup ports in an EtherChannel",
       "desc":"Eight"
    },
    {
       "id":19,
       "topic_id":100,
       "title":"Default priority for Hot Standby Router Protocol (HSRP)",
       "desc":100
    },
    {
       "id":20,
       "topic_id":100,
       "title":"First-hop redundancy protocol that uses multicast address 224.0.0.2",
       "desc":"Hot standby router protocol (HSRP)"
    },
    {
       "id":21,
       "topic_id":100,
       "title":"True/False: A switch configured to use Link Aggregation Control Protocol (LACP) in Active mode will form an EtherChannel with a switch configured with a static EtherChannel.",
       "desc":"FALSE"
    },
    {
       "id":22,
       "topic_id":100,
       "title":"In radio, what decreases with the square of the distance?",
       "desc":"Amplitude"
    },
    {
       "id":23,
       "topic_id":100,
       "title":"Measure of radio signal strength that measures power relative to a single milliwatt",
       "desc":"Decibel-milliwatt (dBm)"
    },
    {
       "id":24,
       "topic_id":100,
       "title":"Unit of measurement for antenna gain",
       "desc":"dB-isotropic (dBi)"
    },
    {
       "id":25,
       "topic_id":100,
       "title":"Antenna type best suited for static point-to-point wireless links",
       "desc":"Parabolic"
    },
    {
       "id":26,
       "topic_id":100,
       "title":"802.11 standards that use the 5 GHz frequency band",
       "desc":"802.11n, 802.11ac, and 802.11ax"
    },
    {
       "id":27,
       "topic_id":100,
       "title":"802.11 standards that use the 2.4 GHz frequency band",
       "desc":"802.11g, 802.11n, and 802.11ax"
    },
    {
       "id":28,
       "topic_id":100,
       "title":"True/False: 802.11 WLAN uses Ethernet frames",
       "desc":"FALSE"
    },
    {
       "id":29,
       "topic_id":100,
       "title":"Intercontroller roam where WLAN controllers don\u0027t share a VLAN",
       "desc":"Layer 3 roam"
    },
    {
       "id":30,
       "topic_id":100,
       "title":"OSPF network type that doesn\u0027t use a designated router",
       "desc":"Point-to-point"
    },
    {
       "id":31,
       "topic_id":100,
       "title":"OSPF link-state advertisement (LSA) that combines type 1 router LSAs and remains in an area",
       "desc":"Type 2 network LSA"
    },
    {
       "id":32,
       "topic_id":100,
       "title":"OSPF link-state advertisement (LSA) that combines type 1 router LSAs and type 2 network LSAs",
       "desc":"Type 3 summary LSA"
    },
    {
       "id":33,
       "topic_id":100,
       "title":"OSPF routers that are not designated routers (DR) or backup DRs form this type of adjacency with each other.",
       "desc":"Two-way"
    },
    {
       "id":34,
       "topic_id":100,
       "title":"Default OSPF interface priority",
       "desc":1
    },
    {
       "id":35,
       "topic_id":100,
       "title":"EIGRP weighted metric formula using default K values",
       "desc":"256 x (bandwidth + delay)"
    },
    {
       "id":36,
       "topic_id":100,
       "title":"Bandwidth value EIGRP uses in the weighted metric formula",
       "desc":"10\u2077 \u00F7 constrained bandwidth"
    },
    {
       "id":37,
       "topic_id":100,
       "title":"Protocol and port BGP uses",
       "desc":"TCP port 179"
    },
    {
       "id":38,
       "topic_id":100,
       "title":"IP protocol OSPF uses",
       "desc":"Protocol 89"
    },
    {
       "id":39,
       "topic_id":100,
       "title":"Frequency of BGP keepalive messages",
       "desc":"60 seconds"
    },
    {
       "id":40,
       "topic_id":100,
       "title":"BGP origin type that\u0027s most preferred",
       "desc":"Interior Gateway Protocol (IGP)"
    },
    {
       "id":41,
       "topic_id":100,
       "title":"Cisco-proprietary, locally significant BGP attribute",
       "desc":"Weight"
    },
    {
       "id":42,
       "topic_id":100,
       "title":"Final BGP tiebreaker",
       "desc":"Lowest router ID (RID)"
    },
    {
       "id":43,
       "topic_id":100,
       "title":"Administrative distance of EIGRP internal route",
       "desc":90
    },
    {
       "id":44,
       "topic_id":100,
       "title":"Administrative distance of EIGRP external route",
       "desc":170
    },
    {
       "id":45,
       "topic_id":100,
       "title":"Administrative distance of static route",
       "desc":1
    },
    {
       "id":46,
       "topic_id":100,
       "title":"Another name for port address translation",
       "desc":"network address translation (NAT) overload"
    },
    {
       "id":47,
       "topic_id":100,
       "title":"Beginning of command for translating source IP addresses using static or dynamic network address translation (NAT) or port address translation (PAT)",
       "desc":"ip nat inside source"
    },
    {
       "id":48,
       "topic_id":100,
       "title":"Nonroutable IP multicast range",
       "desc":"224.0.0.0/24"
    },
    {
       "id":49,
       "topic_id":100,
       "title":"Multicast IP range that\u0027s routable on the public Internet",
       "desc":"224.0.1.0/24"
    },
    {
       "id":50,
       "topic_id":100,
       "title":"Destination multicast IP address for IGMP Membership Query",
       "desc":"224.0.0.1"
    },
    {
       "id":51,
       "topic_id":100,
       "title":"Protocol-independent multicast (PIM) mode that does not use a rendezvous point",
       "desc":"Dense mode"
    },
    {
       "id":52,
       "topic_id":100,
       "title":"Command to view IP multicast routing table",
       "desc":"show ip mroute"
    },
    {
       "id":53,
       "topic_id":100,
       "title":"Per-hop behavior (PHB) group for voice bearer traffic",
       "desc":"Expedited forwarding (EF)"
    },
    {
       "id":54,
       "topic_id":100,
       "title":"Assured forwarding code point with the lowest priority and highest drop probability",
       "desc":"AF43"
    },
    {
       "id":55,
       "topic_id":100,
       "title":"Name of default QoS class map",
       "desc":"class-default"
    },
    {
       "id":56,
       "topic_id":100,
       "title":"Class selector for lower-effort traffic",
       "desc":"CS1"
    },
    {
       "id":57,
       "topic_id":100,
       "title":"Class selector for best-effort traffic",
       "desc":"CS0"
    },
    {
       "id":58,
       "topic_id":100,
       "title":"Per-hop behavior group that includes drop precedence",
       "desc":"Assured forwarding (AF)"
    },
    {
       "id":59,
       "topic_id":100,
       "title":"Formula to find the decimal value of an assured forwarding (AF) code point",
       "desc":"8x + 2y, where x is the priority and y is the drop probability"
    },
    {
       "id":60,
       "topic_id":100,
       "title":"In three-color policing, the color of exceeding traffic",
       "desc":"Yellow"
    },
    {
       "id":61,
       "topic_id":100,
       "title":"In three-color policing, the color of violating traffic",
       "desc":"Red"
    },
    {
       "id":62,
       "topic_id":100,
       "title":"Bandwidth-constrained queuing algorithm for voice bearer traffic",
       "desc":"Low latency queuing (LLQ)"
    },
    {
       "id":63,
       "topic_id":100,
       "title":"Queuing algorithm for TCP-based traffic",
       "desc":"Class-based weighted fair queuing (CBWFQ)"
    },
    {
       "id":64,
       "topic_id":100,
       "title":"TCP behavior caused by tail-drops",
       "desc":"TCP global synchronization"
    },
    {
       "id":65,
       "topic_id":100,
       "title":"Phenomenon that occurs when TCP and UDP packets are tail-dropped",
       "desc":"TCP starvation/UDP dominance"
    },
    {
       "id":66,
       "topic_id":100,
       "title":"Policy map configuration command to enable low latency queuing (LLQ)",
       "desc":"priority"
    },
    {
       "id":67,
       "topic_id":100,
       "title":"Policy map configuration command to enable class-based weighted fair queuing (CBWFQ)",
       "desc":"bandwidth"
    },
    {
       "id":68,
       "topic_id":100,
       "title":"Policy map configuration command to enable weighted random early detection (WRED)",
       "desc":"random-detect"
    },
    {
       "id":69,
       "topic_id":100,
       "title":"Interface command to apply a QoS policy map",
       "desc":"service-policy"
    },
    {
       "id":70,
       "topic_id":100,
       "title":"Ethernet frame field used for QoS classification marking (three names)",
       "desc":"802.1p, priority code point (PCP), or class of service (CoS) field"
    },
    {
       "id":71,
       "topic_id":100,
       "title":"QoS tool that delays traffic in order to prevent packet loss",
       "desc":"Shaping"
    },
    {
       "id":72,
       "topic_id":100,
       "title":"QoS tool that drops packets in order to prevent congestion",
       "desc":"Policing"
    },
    {
       "id":73,
       "topic_id":100,
       "title":"Hypervisor type designed to run on server hardware",
       "desc":"Type-1"
    },
    {
       "id":74,
       "topic_id":100,
       "title":"Hypervisor type designed to run on personal computers",
       "desc":"Type-2"
    },
    {
       "id":75,
       "topic_id":100,
       "title":"Network virtualization technology that allows multiple virtual network functions (VNFs) to share a single physical network interface card (NIC)",
       "desc":"Single-root I/O virtualization (SR-IOV)"
    },
    {
       "id":76,
       "topic_id":100,
       "title":"Type of bridging that uses an external switch to connect virtual machines running on the same host (two names)",
       "desc":"Edge virtual bridging or reflective relay"
    },
    {
       "id":77,
       "topic_id":100,
       "title":"Standardized protocol for layer 2 over layer 3 encapsulation",
       "desc":"Virtual Extensible LAN (VXLAN)"
    },
    {
       "id":78,
       "topic_id":100,
       "title":"GRE IP protocol number",
       "desc":"Protocol 47"
    },
    {
       "id":79,
       "topic_id":100,
       "title":"Phenomenon that occurs when a route to a tunnel endpoint uses the tunnel interface itself as the next hop",
       "desc":"Recursive routing"
    },
    {
       "id":80,
       "topic_id":100,
       "title":"Protocol that provides authentication and encryption for IPsec",
       "desc":"Encapsulating security payload (ESP)"
    },
    {
       "id":81,
       "topic_id":100,
       "title":"IP protocol for encapsulating security payload (ESP)",
       "desc":"Protocol 50"
    },
    {
       "id":82,
       "topic_id":100,
       "title":"Protocol and port used for Internet Key Exchange (IKE)?",
       "desc":"UDP port 500"
    },
    {
       "id":83,
       "topic_id":100,
       "title":"IPsec mode in which entire IP packet is encrypted",
       "desc":"Tunnel mode"
    },
    {
       "id":84,
       "topic_id":100,
       "title":"IPsec mode in which only the IP payload is encrypted but the IP header is not",
       "desc":"Transport mode"
    },
    {
       "id":85,
       "topic_id":100,
       "title":"Protocol and port for VXLAN",
       "desc":"UDP port 4789"
    },
    {
       "id":86,
       "topic_id":100,
       "title":"Underlay IP routing protocol used by SD-Access",
       "desc":"Intermediate System to Intermediate System (IS-IS)"
    },
    {
       "id":87,
       "topic_id":100,
       "title":"Control plane protocol SD-Access uses for routing and forwarding",
       "desc":"Lisp"
    },
    {
       "id":88,
       "topic_id":100,
       "title":"Cisco DNA Center workflow where you configure scalable group tags (SGTs)",
       "desc":"Cisco DNA Policy"
    },
    {
       "id":89,
       "topic_id":100,
       "title":"Standardized network device configuration protocol that uses HTTP actions",
       "desc":"RESTCONF"
    },
    {
       "id":90,
       "topic_id":100,
       "title":"Format that both NETCONF and RESTCONF support for storing configuration data",
       "desc":"Extensible Markup Language (XML)"
    },
    {
       "id":91,
       "topic_id":100,
       "title":"Device terminal line used for SSH and telnet connections",
       "desc":"Virtual terminal (vty)"
    },
    {
       "id":92,
       "topic_id":100,
       "title":"Terminal line command to enable local authentication",
       "desc":"login local"
    },
    {
       "id":93,
       "topic_id":100,
       "title":"Authentication server that can be used with 802.1X EAP",
       "desc":"Remote Authentication Dial-In User Service (RADIUS)"
    },
    {
       "id":94,
       "topic_id":100,
       "title":"Cisco\u0027s DNS-based security service",
       "desc":"Umbrella"
    },
    {
       "id":95,
       "topic_id":100,
       "title":"Term for using scalable group tags to enforce policy at an egress point",
       "desc":"TrustSec"
    },
    {
       "id":96,
       "topic_id":100,
       "title":"Machine authentication mechanism used in lieu of 802.1X",
       "desc":"MAC authentication bypass (MAB)"
    },
    {
       "id":97,
       "topic_id":100,
       "title":"MACsec protocol used between a switch and an endpoint",
       "desc":"MACsec key agreement (MKA)"
    },
    {
       "id":98,
       "topic_id":100,
       "title":"Number of syslog severity levels",
       "desc":"Eight"
    },
    {
       "id":99,
       "topic_id":100,
       "title":"Port mirroring technology that can mirror traffic across routed links",
       "desc":"Encapsulated Remote SPAN (RSPAN)"
    },
    {
       "id":100,
       "topic_id":100,
       "title":"Secondary static route configured with a higher administrative distance than the primary static route",
       "desc":"Floating static route"
    },
    {
       "id":101,
       "topic_id":200,
       "title":"Understand why IP addresses and MAC addresses name interfaces, not nodes.",
       "desc":"An interface is bound to a subnet, and a node can have multiple interfaces. Other nodes in the same subnet can\u0027t determine whether any two MAC or IP addresses belong to the same node."
    },
    {
       "id":102,
       "topic_id":200,
       "title":"Know how switches extend a subnet across different physical media.",
       "desc":"Switches use flooding to forward broadcasts and unknown unicasts to all connected nodes in a given VLAN."
    },
    {
       "id":103,
       "topic_id":200,
       "title":"Understand how routers enable IP connectivity between subnets.",
       "desc":"When a router receives a layer 2 frame containing an IP packet, it decapsulates the packet and looks at the destination IP address. It checks its FIB to determine the next hop\u0027s IP address. If the next hop is reachable via Ethernet, it re-encapsulates the packet in an Ethernet frame addressed to the next-hop node\u0027s MAC address and forwards it. If the next hop is reachable via a PPP or HDLC connection, it encapsulates the IP packet in a PPP or HDLC frame and forwards it."
    },
    {
       "id":104,
       "topic_id":200,
       "title":"Know the encapsulation and decapsulation process for the protocols at each layer.",
       "desc":"With the exception of the Application layer, the PDU at each layer contains a reference to a protocol in the layer above. For example, an Ethernet frame contains a Type field that indicates a Network layer protocol, such as IPv4 (0x0800) or IPv6 (0x86DD). An IP packet contains a Protocol field indicating a Transport layer protocol, such as TCP (6) or UDP (17)."
    },
    {
       "id":105,
       "topic_id":200,
       "title":"Understand the primary purpose of each layer.",
       "desc":"The Data Link layer facilitates data transfer between two nodes connected to a shared medium. The Network layer enables data transfer between nodes that may or may not be in the same subnet. The Transport layer facilitates application-to-application data transfer and provides error detection."
    },
    {
       "id":106,
       "topic_id":200,
       "title":"Be able to determine the root bridge, root ports, and designated ports for any Spanning Tree topology.",
       "desc":"Because a layer 2 loop can bring down a network, you must be able to understand what Spanning Tree will do before you configure it or add a new switch to an existing network. Experimenting is a recipe for disaster!"
    },
    {
       "id":107,
       "topic_id":200,
       "title":"Understand the differences among PVST+, RPVST+, and MST. PVST+ is the original Cisco implementation of the timer-based 802.1D Spanning Tree specification.",
       "desc":"RPVST+ doesn\u0027t use timers, introduces link types, and has a faster convergence time. (R)PVST+ creates a separate Spanning Tree instance for each VLAN. MST lets you map multiple VLANs to a single MST instance, which is useful if you have a large number of VLANs."
    },
    {
       "id":108,
       "topic_id":200,
       "title":"Know how to manipulate active and allowed VLANs on a trunk. By default, all VLANs (1-4094) are allowed on a trunk.",
       "desc":"In order for a VLAN to be allowed and active on one end of a trunk, the VLAN must exist on the switch and not be shut down. If a VLAN is shut down, it will show as allowed but not active. If a VLAN is pruned or blocked, it will show as neither allowed nor active."
    },
    {
       "id":109,
       "topic_id":200,
       "title":"Be able to configure all Spanning Tree modes.",
       "desc":"Although PVST+ is deprecated, its configuration commands are similar to RPVST+, and you may still encounter PVST+ on older gear. Be able to configure (R)PVST+ and MST to customize the root bridge, root ports, and designated ports."
    },
    {
       "id":110,
       "topic_id":200,
       "title":"Understand the interactions between RPVST+ and MST.",
       "desc":"Although this is something that you\u0027re more likely to see on an exam than in real life, practicing running RPVST+ and MST concurrently in your lab will solidify your understanding of both. In particular, understand how MST simulates RPVST+."
    },
    {
       "id":111,
       "topic_id":200,
       "title":"Know the functions of the layers in the two-tier and three-tier architectures.",
       "desc":"The three-tier architecture consists of a core layer, distribution/aggregation layer, and access layer. The two-tier architecture collapses the core and distribution layer into a single layer called a collapsed core."
    },
    {
       "id":112,
       "topic_id":200,
       "title":"Know the difference between switched (layer 2) and routed (layer 3) interfaces.",
       "desc":"A switched interface is a VLAN access or trunk port and can\u0027t have an IP address assigned. A routed interface has no VLAN and can have an IP address assigned to it."
    },
    {
       "id":113,
       "topic_id":200,
       "title":"Understand the common layer 2 topologies.",
       "desc":"Switched topologies include looped, loop-free, and VSS. The routed topology eliminates spanned VLANs and instead places each interswitch link into a separate broadcast domain."
    },
    {
       "id":114,
       "topic_id":200,
       "title":"Be able to configure layer 2 and layer 3 EtherChannels.",
       "desc":"An EtherChannel can consist of 1–8 active links. You can create a static port channel or let LACP or PAgP negotiate one for you. The difference between a layer 2 and a layer 3 EtherChannel is determined by whether the member interfaces are switched or routed."
    },
    {
       "id":115,
       "topic_id":200,
       "title":"Be able to configure the first-hop redundancy protocols.",
       "desc":"The configuration semantics of VRRP, HSRP, and GLBP are strikingly similar, often differing by only one word. I suggest mastering VRRP first. You\u0027ll then be able to transfer much of that knowledge to HSRP and GLBP."
    },
    {
       "id":116,
       "topic_id":200,
       "title":"Understand when retransmissions occur.",
       "desc":"Retransmissions are usually the result of interference, obstacles, or insufficient signal strength. They have a profound impact on throughput and can result in the AP and client switching to a slower but more reliable modulation scheme. Reducing interference and increasing RSSI can keep you out of the woods."
    },
    {
       "id":117,
       "topic_id":200,
       "title":"Know the major differences between 802.11 standards.",
       "desc":"You don\u0027t need to know all the details, but knowing which standards use the 2.4 GHz and 5 GHz bands, as well as the top data throughput speeds of each standard, is important. Remember that 2.4 GHz and 5 GHz radios aren\u0027t compatible."
    },
    {
       "id":118,
       "topic_id":200,
       "title":"Understand the various authentication and encryption types.",
       "desc":"Authentication and encryption are different but are often used together. An open system has no encryption and may or may not use WebAuth for authentication. This is what you\u0027ll typically find in coffee shops. WPA Personal mode uses a preshared key for both authentication and encryption. WPA Enterprise mode uses 802.1X and EAP."
    },
    {
       "id":119,
       "topic_id":200,
       "title":"Be able to describe how roaming works in autonomous and lightweight deployments.",
       "desc":"Roaming is what sets wireless networks apart from wired networks. Clients are free to move about and expect the network to follow them, in a sense. Roaming is the client disassociating from one AP and associating with another using the same SSID. What matters is how the backend WLAN infrastructure handles this MAC move."
    },
    {
       "id":120,
       "topic_id":200,
       "title":"Understand the various antenna types.",
       "desc":"Omnidirectional antennas are the most common and have a relatively low gain. Directional or high-gain antennas are used to direct a signal toward a specific area. Directional antennas are most often used to connect two backhaul radios in a point-to-point fashion."
    },
    {
       "id":121,
       "topic_id":200,
       "title":"Know how OSPF adjacencies form.",
       "desc":"How adjacencies form depends on the network type, which can be broadcast or point-to-point. Know how to configure the network type and understand how it impacts LSA exchanges and neighbor states."
    },
    {
       "id":122,
       "topic_id":200,
       "title":"Understand the purposes of the various LSA types.",
       "desc":"The variety of OSPF LSA types isn\u0027t to make your life difficult, but to make OSPF more scalable. Understand what information each LSA type carries and why it exists."
    },
    {
       "id":123,
       "topic_id":200,
       "title":"Be able to configure OSPF.",
       "desc":"You should be able to configure OSPF and its key features from scratch. A crucial part of configuration is verification, so be able to confirm that your configuration works as expected."
    },
    {
       "id":124,
       "topic_id":200,
       "title":"Know how to read the LSDB.",
       "desc":"Each router uses its LSDB to build the IP routing table. Being able to read and understand the link-state database on a router is an important troubleshooting skill."
    },
    {
       "id":125,
       "topic_id":200,
       "title":"Understand how the DUAL algorithm chooses successors and feasible successors.",
       "desc":"You should be able to determine the successors and feasible successors just by looking at a layer 3 network diagram."
    },
    {
       "id":126,
       "topic_id":200,
       "title":"Be able to configure EIGRP and adjust metrics.",
       "desc":"As with all IGPs, be able to configure EIGRP and modify metrics to control the successor and feasible successor selections."
    },
    {
       "id":127,
       "topic_id":200,
       "title":"Know the differences between equal cost multipathing and unequal cost multipathing.",
       "desc":"ECMP is used when there are multiple successors—that is, when multiple routes have an equal cost. Unequal cost multipathing can be enabled by adjusting the variance. By default, EIGRP will install up to four routes to the same prefix."
    },
    {
       "id":128,
       "topic_id":200,
       "title":"Know the attributes BGP uses for path selection.",
       "desc":"It\u0027s not always practical to configure every scenario, so you should be able to determine which route BGP will select as the best path just by looking at the route\u0027s attributes."
    },
    {
       "id":129,
       "topic_id":200,
       "title":"Understand the difference between redistributed routes and routes advertised using the network command.",
       "desc":"BGP can originate routes by redistributing them from an IGP, connected routes, or static routes. You can also have BGP originate a route from any entry in the IP routing table by using the network command."
    },
    {
       "id":130,
       "topic_id":200,
       "title":"Be able to configure eBGP peerings, advertise and filter routes, and modify attributes.",
       "desc":"Naturally, you should be able to configure eBGP peerings and originate routes. You\u0027ll also need to be comfortable with using IP prefix lists and route maps to modify and filter routes, not just for BGP but for IGPs as well."
    },
    {
       "id":131,
       "topic_id":200,
       "title":"Understand the differences among static NAT, dynamic NAT, and PAT.",
       "desc":"Static NAT does a one-to-one translation from inside local to inside global. Dynamic NAT also does a one-to-one translation from local to global, but the allocation happens dynamically, and the global addresses are pulled from a pool. PAT, or NAT overload, does a many-to-one translation, typically translating multiple local IPs to a single global address."
    },
    {
       "id":132,
       "topic_id":200,
       "title":"Be able to configure NAT.",
       "desc":"You should be able to configure static NAT, dynamic NAT, and most importantly PAT, or NAT overload. Although outside static NAT is not something that you\u0027re likely to encounter much on the job, some practice configuring it can help solidify your understanding of NAT."
    },
    {
       "id":133,
       "topic_id":200,
       "title":"Know how to use access lists and NAT pools.",
       "desc":"NAT configuration on Cisco devices also makes use of ACLs. If you aren\u0027t comfortable with ACLs, you\u0027re not going to be very comfortable configuring NAT. NAT pools are used for specifying multiple inside global addresses."
    },
    {
       "id":134,
       "topic_id":200,
       "title":"Understand the differences between multicast and unicast.",
       "desc":"Unicast requires a separate packet for each destination host. This allows independently tracking sessions per host. Multicast requires one packet sent to a multicast address, and the routers on the network take care of distributing it to the hosts that need it. The sender is unaware of which hosts are listening and who has received a packet."
    },
    {
       "id":135,
       "topic_id":200,
       "title":"Know the difference between Ethernet multicast and IP multicast.",
       "desc":"The biggest difference is that Ethernet multicast frames stay within a broadcast domain, whereas IP multicast can—with some exceptions—be routed. IP multicast packets may or may not stay within a broadcast domain, depending on the multicast group address and TTL. Packets sent to addresses in the local network control block (224.0.0.0/24) aren\u0027t routed. This is the case with multicasts generated by IGPs such as EIGRP and OSPF. Also, it\u0027s possible for a source to send a multicast IP packet with a TTL of 1, ensuring that it won\u0027t leave the broadcast domain."
    },
    {
       "id":136,
       "topic_id":200,
       "title":"Know the reasons for using policing and shaping.",
       "desc":"Policing helps prevent congestion by dropping inbound or outbound packets that would cause congestion. Shaping delays outbound packets to avoid packet loss."
    },
    {
       "id":137,
       "topic_id":200,
       "title":"Understand how packets are marked.",
       "desc":"The usual way of marking packets is using class maps and policy maps. But you can also use policing to mark packets according to color."
    },
    {
       "id":138,
       "topic_id":200,
       "title":"Understand how queuing works.",
       "desc":"Queuing works like this: Packets are sorted into multiple queues. The queuing algorithm services each queue on a schedule according to its configured bandwidth. LLQs are always serviced first. Within any queue, packets are processed in FIFO order. In other words, once packets are in a queue, they\u0027re not rearranged. Some may be dropped, as in the case of WRED, but not shuffled around."
    },
    {
       "id":139,
       "topic_id":200,
       "title":"Be able to configure policing, shaping, and queuing.",
       "desc":"A little practice goes a long way! Keep it simple but spend some time practicing configuring two and three-color policing and shaping. Then try your hand at configuring CBWFQ and low-latency queuing."
    },
    {
       "id":140,
       "topic_id":200,
       "title":"Know what network functions virtualization means.",
       "desc":"Network functions virtualization (NFV) refers to using commodity servers and VM infrastructure to run virtual network appliances such as routers, switches, firewalls, load balancers, and WAN optimizers, or VNFs."
    },
    {
       "id":141,
       "topic_id":200,
       "title":"Understand the purpose and operation of LISP.",
       "desc":"LISP is designed to reduce the size of the global Internet routing tables by tunneling traffic between endpoints that use IP addresses called endpoint identifiers (EIDs). EIDs are reachable only via egress tunnel routers (ETRs) that have publicly reachable IP addresses called RLOCs. Only the RLOCs are advertised into the global routing tables, and the EIDs are not."
    },
    {
       "id":142,
       "topic_id":200,
       "title":"Understand the purpose and operation of VXLAN.",
       "desc":"VXLAN is designed to tunnel MAC frames over layer 3 networks. Natively, VXLAN uses multicast to implement a flood-and-learn approach for MAC address learning. But you can use LISP or EVPN with BGP to implement a separate control plane for MAC address learning."
    },
    {
       "id":143,
       "topic_id":200,
       "title":"Be able to configure GRE tunnels, IPsec tunnels, and VRFs.",
       "desc":"Practice configuring GRE to tunnel IPv4 and IPv6 over IPv4. You should be able to configure a site-to-site VPN using IPsec in transport or tunnel mode. Lastly, be able to configure VRFs to segregate layer 3 traffic on the same router. VRFs are often used with overlays to achieve traffic segregation among different tunnels that terminate on a single router."
    },
    {
       "id":144,
       "topic_id":200,
       "title":"Know the Cisco DNA Center workflows.",
       "desc":"The four workflows are Policy workflow, Assurance workflow, etc."
    },
    {
       "id":145,
       "topic_id":200,
       "title":"Understand the difference between the underlay and overlay networks in SD-Access.",
       "desc":"The underlay network uses the IS-IS routing protocol and PIM sparse mode. The overlay uses LISP with proprietary VXLAN encapsulation."
    },
    {
       "id":146,
       "topic_id":200,
       "title":"Be able to write and execute an EEM applet.",
       "desc":"EEM applets consists of triggering events and actions, the latter including CLI commands. Know how to create EEM applets, both those that are triggered by events and those that must be run manually."
    },
    {
       "id":147,
       "topic_id":200,
       "title":"Know the standard HTTP response codes and what they mean.",
       "desc":"Broadly speaking, 2xx response codes are good and 4xx response codes are bad. In particular, a 401 code indicates that you haven\u0027t authenticated to the API endpoint."
    },
    {
       "id":148,
       "topic_id":200,
       "title":"Be able to configure SSH and console device access using local and AAA authentication.",
       "desc":"This includes knowing how to disable telnet and how to use ACLs to restrict management traffic to VTY lines."
    },
    {
       "id":149,
       "topic_id":200,
       "title":"Know the difference between authentication, authorization, and accounting.",
       "desc":"In short, authentication is a go/no-go decision as to whether a user is permitted to log in. Authorization determines what the user can do after they\u0027ve logged in. Accounting logs what the user did and when."
    },
    {
       "id":150,
       "topic_id":200,
       "title":"Understand the different use cases for TACACS+ and RADIUS.",
       "desc":"Use TACACS+ for device access if you also need authorization and accounting of CLI commands. Use RADIUS if you need 802.1X authentication."
    },
    {
       "id":151,
       "topic_id":200,
       "title":"Be able to configure and apply IP access lists and VLAN access maps.",
       "desc":"IP access lists you should already be familiar with. But note that IP ACLs applied to switchports can\u0027t be used to filter control plane traffic. VLAN access maps (or VACLs) let you control what traffic can ingress or egress a VLAN. IP ACLs and VACLs have one thing in common: an implicit deny at the end of the list."
    },
    {
       "id":152,
       "topic_id":200,
       "title":"Know the differences among Cisco\u0027s security products.",
       "desc":"Specifically, know the key features of Cisco AnyConnect, Umbrella, ThreatGrid, AMP, Firepower NGFW, TrustSec, and MACsec."
    },
    {
       "id":153,
       "topic_id":200,
       "title":"Understand the differences among 802.1X, MAB, and WebAuth.",
       "desc":"All three are used for authentication. 802.1X can be used to authenticate a user and an endpoint. MAB can be used only to authenticate an endpoint. WebAuth can only authenticate a user. Hence, the latter two are often used together when 802.1X isn\u0027t available."
    },
    {
       "id":154,
       "topic_id":200,
       "title":"Be able to configure network monitoring features.",
       "desc":"This includes debugs, SNMP, Syslog, NetFlow, SPAN, and IP SLA."
    }
  ]